import { store } from '../store'

export default {

    data() {
        return {
            state: store.state
        }
    },

    methods: {
        __(key, ...args) {
            if(!this.state || !this.state.locale)
                return ""

            if(!this.state.locale[key] || !this.state.locale[key][this.state.iso]) {
                return `${key}.${this.state.iso}`
            }

            let str = this.state.locale[key][this.state.iso]

            for(let arg of args) {
                str = str.replace('%s', arg)
            }
            return str
        },

        mergeLocale(customLocale) {
            store.setLocale({ ...this.state.locale, ...customLocale })
        },

        setIso(iso) {
            store.setIso(iso)
        }

    }

}